module.exports = __webpack_public_path__ + "img/title2.56a791cd.png";